<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>系統設定</f7-nav-title>
    </f7-navbar>

    <f7-list inline-labels no-hairlines-md>
      <f7-list-item>
        <f7-label>字體大小: {{ settings.fontSize }}</f7-label>
        <f7-range :min="0" :max="100" :step="1" :value="settings.fontSize" :label="true" @range:change="onFontSizeChange" color="orange" />
      </f7-list-item>
      <f7-list-item>
        <f7-label>字體間距: {{ settings.margin }}</f7-label>
        <f7-range :min="0" :max="30" :step="1" :value="settings.margin" :label="true" @range:change="onMarginChange" color="orange" />
      </f7-list-item>
      <f7-list-item title="預約外帶聲音">
        <f7-toggle :checked="settings.preOrderRing" @toggle:change="setPreOrderRing"></f7-toggle>
      </f7-list-item>
      <f7-list-item title="新訂單聲音">
        <f7-toggle :checked="settings.newOrderRing" @toggle:change="setNewOrderRing"></f7-toggle>
      </f7-list-item>
      <f7-list-item>
        <f7-button @click="reset" raised fill>還原成預設值</f7-button>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  dependencies: ['defaultSettings'],
  computed: {
    ...mapState(['settings'])
  },
  methods: {
    ...mapActions([
      'setSettings',
      'setFontSize',
      'setMargin',
      'setNewOrderRing',
      'setPreOrderRing'
    ]),
    onFontSizeChange (fontSize) {
      this.setFontSize(fontSize)
    },
    onMarginChange (margin) {
      this.setMargin(margin)
    },
    reset () {
      this.setSettings(this.defaultSettings)
    }
  }
}
</script>
